// 取得座標距離
export default {
  methods: {
    getCoordinateDistance (longitude1, latitude1, longitude2, latitude2) {
      console.log('getCoordinateDistance', longitude1, latitude1, longitude2, latitude2)
      const newLongitude1 = longitude1 * Math.PI / 180
      const newLatitude1 = latitude1 * Math.PI / 180
      const newLongitude2 = longitude2 * Math.PI / 180
      const newLatitude2 = latitude2 * Math.PI / 180
      const a = newLatitude1 - newLatitude2
      const b = newLongitude1 - newLongitude2
      // 地球半徑，單位米
      const EARTH_RADIUS = 6378137
      const distance = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(newLatitude1) * Math.cos(newLatitude2) * Math.pow(Math.sin(b / 2), 2))) * EARTH_RADIUS
      return distance
    }
  }
}
